export default "__VITE_ASSET__B6oDTL_6__"